import {
  useFormMessages,
  useFormEventStore,
  useScheduleEventStore,
} from "../../hooks";
import {
  ErrorMessage,
  LoadingData,
  MainButton,
  SecondaryButton,
} from "../../ui";

export const PatientSurgeryFinalAssessmentCard = ({ attended }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoading,
    message,
  } = useFormEventStore();

  const {
    // Methods
    startPatientSurgeryAssessmentNoShow,
    startPatientSurgeryFinalAssessment,
  } = useScheduleEventStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
  });

  // Funciones ---------------------------------------------//
  const onSubmitAssessmentNoShow = () => {
    setFormSubmitted(true);
    startPatientSurgeryAssessmentNoShow();
  };

  const onSubmitFinalAssessmentShow = () => {
    setFormSubmitted(true);
    startPatientSurgeryFinalAssessment({ attended: true });
  };

  // Efectos -----------------------------------------------//

  return (
    <div className="card border shadow">
      <div className="card-body">
        <div className="vstack gap-3">
          {attended === null ? (
            <div className="hstack gap-2">
              <SecondaryButton
                className={"ms-auto"}
                onClick={() => onSubmitAssessmentNoShow()}
                disabled={isLoading}
              >
                No asistió
              </SecondaryButton>
              <MainButton
                disabled={isLoading}
                onClick={() => onSubmitFinalAssessmentShow()}
              >
                Asistiío
              </MainButton>
            </div>
          ) : (
            <p className="mb-0">{`El paciente ${
              attended ? "asistió" : "no asistió"
            } a la sesión de finalización ${
              attended ? `y finalizó su procedimiento` : ""
            }`}</p>
          )}

          {isLoading && (
            <div className="col-12">
              <LoadingData />
            </div>
          )}

          {showErrorMessage && (
            <div className="col-md-12">
              <ErrorMessage>{messageText}</ErrorMessage>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
